var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaceholderIcon = function SvgPlaceholderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M17.563 3.689a10.1 10.1 0 0 1 2.754 2.757m-16.634 0A10.1 10.1 0 0 1 6.437 3.69m0 16.622a10.1 10.1 0 0 1-2.754-2.757m16.634 0a10.1 10.1 0 0 1-2.754 2.757M10.056 2.19a10.1 10.1 0 0 1 3.898.002M2.192 13.954a10.1 10.1 0 0 1-.002-3.898M13.944 21.81a10.1 10.1 0 0 1-3.898-.002m11.762-11.762c.255 1.286.256 2.612.002 3.898"
  })));
};
export default SvgPlaceholderIcon;